import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useThemeMode } from '../../contexts/ThemeContext';

const BrandedSpinner = ({ message }: { message: string }) => {
  const theme = useTheme();
  const { themeMode } = useThemeMode();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <img
        src={
          themeMode === 'dark'
            ? '/Bidlogiq_Logo-Long_Reversed.png'
            : '/Bidlogiq_Logo-Long_Full_colours.png'
        }
        alt="BIDLOGIQ Logo"
        style={{ height: '75px', width: 'auto', marginBottom: '16px' }}
      />
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>{message}</Typography>
    </Box>
  );
};

export default BrandedSpinner;
